const PENDING_ADD_ADMIN_KEY_PREFIX = 'add-admin-after-mfa:';

type PendingAddAdmin = {
  email: string;
};

function getPendingAddAdminKey(id: string) {
  return `${PENDING_ADD_ADMIN_KEY_PREFIX}${id}`;
}

function createPendingAddAdminId() {
  return crypto.randomUUID();
}

export function createPendingAddAdmin(email: string) {
  const id = createPendingAddAdminId();

  try {
    sessionStorage.setItem(getPendingAddAdminKey(id), JSON.stringify({ email } satisfies PendingAddAdmin));
    return id;
  } catch {
    return undefined;
  }
}

export function getPendingAddAdminEmail(id?: string) {
  if (!id) return undefined;

  try {
    const item = sessionStorage.getItem(getPendingAddAdminKey(id));
    if (!item) return undefined;

    const pendingAddAdmin = JSON.parse(item) as Partial<PendingAddAdmin>;
    return typeof pendingAddAdmin.email === 'string' ? pendingAddAdmin.email : undefined;
  } catch {
    return undefined;
  }
}

export function deletePendingAddAdmin(id?: string) {
  if (!id) return;

  try {
    sessionStorage.removeItem(getPendingAddAdminKey(id));
  } catch {
    return;
  }
}
